import React from 'react';
import Pagination from './Pagination';

function TableFooter({
  currentPage,
  totalPages,
  pageSize,
  totalEntries,
  onPageChange
}) {
  if (totalEntries === 0) return null;
  const start = (currentPage - 1) * pageSize + 1;
  const end = totalEntries > currentPage * pageSize ? currentPage * pageSize : totalEntries;

  return (
    <div className='d-sm-flex text-center justify-content-between align-items-center mt-3'>
      <div className='dataTables_info'>
        {`Showing ${start} to ${end} of ${totalEntries} entries`}
      </div>
      <div className='dataTables_paginate paging_simple_numbers' id='example5_paginate'>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
}

export default TableFooter;
